module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "fade-and-fall"
    }
  }, [_c('section', {
    staticClass: "device-pairing-modal modal",
    class: _vm.isFirstPairing ? 'device-pairing-modal--first-pairing' : ''
  }, [_c('div', {
    staticClass: "modal__container--row",
    on: {
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        return _vm.close()
      }
    }
  }, [_c('div', {
    staticClass: "device-pairing-modal__container modal__body"
  }, [_c('div', {
    staticClass: "modal__section modal__header"
  }, [_c('h2', {
    staticClass: "modal__title title--general title--2"
  }, [_vm._v("\n\t\t\t\t\t\tAdd a new device\n\t\t\t\t\t")]), _vm._v(" "), _c('button', {
    staticClass: "modal__close-button",
    on: {
      "click": function($event) {
        return _vm.close()
      }
    }
  }, [_c('svg-icon', {
    staticClass: "modal__close-button__icon",
    attrs: {
      "icon": "x"
    }
  })], 1)]), _vm._v(" "), _c('device-pairing', {
    attrs: {
      "sectionWrapperClass": "modal__section",
      "pinRefreshable": true
    }
  })], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e01944d6","hasScoped":false}!./app/components/device-pairing-modal/template.html
// module id = 371
// module chunks = 0